import React from 'react';
import './Team.css';

const members = [
  { name: 'James Byarlay', role: 'President', initials: 'JB' },
  { name: 'Maria Alvarez', role: 'Vice President', initials: 'MA' },
  { name: 'Robert Hale', role: 'Operations Manager', initials: 'RH' },
  { name: 'Lisa Nguyen', role: 'Project Manager', initials: 'LN' },
];

const Team = () => {
  return (
    <section className="team-section">
      <div className="container">
        <h2>Our Team</h2>
        <div className="team-divider"></div>
        <p className="team-intro">
          Leadership at Carmel Lahaina Utility Services
        </p>

        <div className="team-grid">
          {members.map((member) => (
            <article className="team-card" key={member.name}>
              <div className="team-avatar" aria-hidden="true">{member.initials}</div>
              <h3>{member.name}</h3>
              <p className="team-role">{member.role}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
